import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { collection, getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyATBzQqYgASGo72GRR6TkMnkGMj-iQQozM',
  authDomain: 'longphamdev-portfolio-dashboar.firebaseapp.com',
  projectId: 'longphamdev-portfolio-dashboar',
  storageBucket: 'longphamdev-portfolio-dashboar.appspot.com',
  messagingSenderId: '1018345859902',
  appId: '1:1018345859902:web:f5838ad0d6309aab7eda6f',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth()
const provider = new GoogleAuthProvider()
export const db = getFirestore(app)
export const storage = getStorage(app)
export const colRef = collection(db, 'project')
export const signInWithGoogle = () => signInWithPopup(auth, provider)
